import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { initialState, SLICE_NAMESPACE } from './orders.constants';
import { reducers } from './orders.reducer';

const ordersSlice = createSlice({
  name: SLICE_NAMESPACE,
  initialState,
  reducers,
  extraReducers,
});

export const { updateOrderFilters, resetOrderDetail } = ordersSlice.actions;

export default ordersSlice.reducer;
